var React = require('react');

function WalletInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.178 2.534L19.673 7h.559c1.426 0 2.669.932 2.762 2.23l.006.157V11a1 1 0 011 1v5a1 1 0 01-1 1v1.613C23 20.992 21.715 22 20.232 22H2.768C1.285 22 0 20.992 0 19.613V9.387C0 8.008 1.285 7 2.768 7h.955l9.367-5.585c1.433-.855 3.268-.347 4.088 1.12zM3.886 9H2.768C2.298 9 2 9.234 2 9.387v10.226c0 .153.298.387.768.387h17.464c.47 0 .768-.234.768-.387V18h-5.5a3.5 3.5 0 010-7H21V9.387c0-.138-.241-.341-.633-.38L20.232 9h-9.418c-1.749.02-3.348.032-4.544.035-.73.002-1.301 0-1.694-.005a15.17 15.17 0 01-.488-.013 2.336 2.336 0 01-.192-.016L3.886 9zM22 13h-6.5a1.5 1.5 0 000 3H22v-3zm-7.886-9.867L7.629 7h3.195a901.089 901.089 0 005.803-.084l.7-.014-1.895-3.392c-.273-.489-.859-.65-1.318-.377z"}));
}

WalletInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = WalletInline;

WalletInline.default = WalletInline;
